module.exports = __webpack_public_path__ + "static/index/img/baikal-306.b86c4357.jpg";